const BOT_NAME_POOL = [
  "Alex",
  "Jordan",
  "Casey",
  "Taylor",
  "Morgan",
  "Riley",
  "Jamie",
  "Avery",
  "Quinn",
  "Reese",
  "Dakota",
  "Skyler",
  "Rowan",
  "Emerson",
  "Finley",
  "Harper",
  "Hayden",
  "Peyton",
  "Sawyer",
  "Blake",
  "Charlie",
  "Drew",
  "Elliot",
  "Frankie",
  "Kendall",
  "Logan",
  "Marlowe",
  "Parker",
  "Remy",
  "Sam",
];

// Picks 3 distinct random names (for seats P2/P3/P4) so bots feel like real
// opponents instead of "Player 2/3/4". Called once per new game so the
// names stay stable for the rest of that session.
const generateBotNames = () => {
  const shuffled = [...BOT_NAME_POOL].sort(() => Math.random() - 0.5);
  const [nameP2, nameP3, nameP4] = shuffled;
  return { P2: nameP2, P3: nameP3, P4: nameP4 };
};

export { generateBotNames };
